<template>
  <div>
    <template>
      <smallheader></smallheader>
    </template>
    <div class="context" id="pdfget" style="overflow-y: auto;">
      <div class="titile1">{{questionObject.name}}</div>
      <div class="da" v-for="(item,index) in allData" :key="index" v-show="item.type!==3">
        <div class="contexa">
          <div>{{index+1}}.{{item.name}}</div>
          <el-table :data="item.choiceList" style="width: 100%;">
            <el-table-column prop="name" label="选项"></el-table-column>
            <el-table-column label="百分比">
              <template slot-scope="scope">
                <el-progress
                  :text-inside="true"
                  :stroke-width="26"
                  :percentage="scope.row.percentage"
                ></el-progress>
              </template>
            </el-table-column>
            <el-table-column prop="count" label="数量" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as vote from '@/api/vote/vote.js';
import smallheader from '../../smallHeader/index';
export default {
  components: { smallheader },

  data() {
    return {
      dialogVisible: false,
      activeName: 'first',
      currentPage: 1,
      pageSize: 10,
      allData: '',
      questionObject: '',
      chartData: [],
      topicId: this.$route.query.topicId,
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    getlist() {
      let than = this;
      let para = { topicId: this.topicId };
      //查询当前主题下的题目信息
      vote.getQuestionTJ(para).then((res) => {
        than.allData = res.result;
        // console.log(res.result);
      });
      let para2 = { id: this.topicId };
      //查询出当前单个主题的基本信息
      vote.getPollGetTongJi(para2).then((res) => {
        // console.log(res)
        this.questionObject = res.result;
      });
    },
  },
};
</script>
<style scoped>
.context {
  max-width: 1200px;
  padding: 20px;
  border: solid 1px #f2f2f2;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 20px;
  min-height: 740px;
}
.titile1 {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
}
.da {
  max-width: 800px;
  margin-left: 50px;
  background-color: #fff;
  margin-top: 20px;
}
.button {
  text-align: right;
  margin-right: 66px;
}
.heightlight {
  background-color: rgba(72, 118, 196, 0.95) !important;
  border: 1px solid #4876c4;
  color: #f8fafc !important;
}
.contexa {
  margin-left: 10px;
}
</style>
